module.exports = __webpack_public_path__ + "static/sumanus-7390ae8230b1273d269aed1c130dbba7.svg";